<script>
import {Carousel, Slide} from "vue-carousel";
import Layout from "@/pages/home/layout";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

/**
 * Basic-table component
 */
export default {
  page: {
    title: "Basic Tables",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Basic Tables",
      items: [
        {
          text: "Tables",
          href: "/",
        },
        {
          text: "Basic Tables",
          active: true,
        },
      ],
      currentPage: 1,
      totalRows: 1,
      perPage: 6,
    };
  },
  onCreated(){
    let authUser = localStorage.getItem("auth-user");
    if (authUser) {
      let jsonUserCurrent = JSON.parse(authUser);
      this.currentUserAuth = jsonUserCurrent;
      console.log("CURRENT USER AUTH  created : ", this.currentUserAuth)
    }
    window.location.href = "https://paht.dongthap.gov.vn/tao-phan-anh"
  },
  mounted() {
    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableData.length;

    this.todoTotalRows = this.todos.length;
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },
  }
};
</script>

<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
        <div class="card container">
          <div class="card-body">
            <h1 class="card-title">Hỏi đáp</h1>
            <p class="card-title-desc">

            </p>

            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th style="width: 50%;">Danh sách câu hỏi</th>
                    <th style="width: 50%;">Danh sách câu trả lời</th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in 4" :key="i">
                    <td>59/2020/QH14</td>
                    <td>17/06/2020</td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row mb-4">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="customPagination"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
    </Layout>
</template>

<style>
.card{
    margin-top: 230px;
}

.card-title{
    font-size: 20px;
    color: #000;
}

.table th{
  background-color: rgb(9, 100, 9);
  color: #fff;
  font-size: 16px;
  border: 1px solid #ccc;
}

.table td{
  font-size: 16px;
}

.page-item.active .page-link {
  background-color: rgb(9, 100, 9) !important;
}

</style>
